/**
 * Converts form values to a string-keyed record suitable for URL query params
 * or navigation payloads. Strips out `undefined`, `null`, empty strings, and
 * `false` booleans so only meaningful values are serialised.
 *
 * @param formValues - Partial form values object (e.g. from MaximumMortgageWizard)
 * @returns A flat `Record<string, string>` with stringified values
 */
export const formValuesToStringParams = (
  formValues: Record<string, unknown>,
): Record<string, string> => {
  const params: Record<string, string> = {};

  for (const [key, value] of Object.entries(formValues)) {
    if (
      value !== undefined &&
      value !== null &&
      value !== "" &&
      value !== false
    ) {
      params[key] = String(value);
    }
  }

  return params;
};
